import React from 'react';
import styled from 'astroturf/react';
import { BodyLink } from 'js/design_system/link/BodyLink';
import { currentUser } from 'js/utils/user';
import { ImpressionWatcher } from 'js/utils/impressions';
import _Container from "SuggestedContentSidebar-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/SuggestedContentSidebar.tsx?styleId=Container";
import _Header from "SuggestedContentSidebar-Header.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/SuggestedContentSidebar.tsx?styleId=Header";
import _ViewMoreButton from "SuggestedContentSidebar-ViewMoreButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/SuggestedContentSidebar.tsx?styleId=ViewMoreButton";
import _Title from "SuggestedContentSidebar-Title.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/SuggestedContentSidebar.tsx?styleId=Title";


const Container = /*#__PURE__*/styled("ul", null, {
  displayName: "Container",
  styles: _Container
});

const Header = /*#__PURE__*/styled("div", null, {
  displayName: "Header",
  styles: _Header
});

const ViewMoreButton = /*#__PURE__*/styled(BodyLink, null, {
  displayName: "ViewMoreButton",
  styles: _ViewMoreButton
});

const Title = /*#__PURE__*/styled(BodyLink, null, {
  displayName: "Title",
  styles: _Title
});

type Props = {
  viewAllUrl?: string;
  headerText: string;
  className?: string;
  impressionSource: string;
};

const SuggestedContentSidebar: React.FC<React.PropsWithChildren<Props>> = ({
  viewAllUrl,
  headerText,
  className,
  impressionSource,
  children,
}) => (
  <div className={className}>
    <Header>
      <Title bold>{headerText}</Title>
      {currentUser && viewAllUrl && (
        <ImpressionWatcher active={true} source={impressionSource}>
          <ViewMoreButton href={viewAllUrl}>View all</ViewMoreButton>
        </ImpressionWatcher>
      )}
    </Header>
    <Container>{children}</Container>
  </div>
);

export default SuggestedContentSidebar;
